if (!customElements.get('vantho-delivery-estimate')) {
  customElements.define(
    'vantho-delivery-estimate',
    class VanthoDeliveryEstimate extends HTMLElement {
      connectedCallback() {
        if (this.isConnectedAndReady) return;

        this.isConnectedAndReady = true;
        this.locale = document.documentElement.lang || 'da-DK';
        this.handlePageReturn = () => {
          if (document.visibilityState === 'visible') {
            this.updateDates();
            this.scheduleMidnightUpdate();
          }
        };

        document.addEventListener('visibilitychange', this.handlePageReturn);
        window.addEventListener('pageshow', this.handlePageReturn);
        this.updateDates();
        this.scheduleMidnightUpdate();
      }

      disconnectedCallback() {
        window.clearTimeout(this.midnightTimer);
        document.removeEventListener('visibilitychange', this.handlePageReturn);
        window.removeEventListener('pageshow', this.handlePageReturn);
        this.isConnectedAndReady = false;
      }

      addDays(date, amount) {
        return new Date(date.getFullYear(), date.getMonth(), date.getDate() + amount);
      }

      addBusinessDays(date, amount) {
        const result = new Date(date);
        let added = 0;
        while (added < amount) {
          result.setDate(result.getDate() + 1);
          const day = result.getDay();
          if (day !== 0 && day !== 6) added++;
        }
        return result;
      }

      dateAttribute(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      }

      formatDate(date) {
        const parts = new Intl.DateTimeFormat(this.locale, {
          day: '2-digit',
          month: 'short'
        }).formatToParts(date);
        const day = String(parts.find((part) => part.type === 'day')?.value || date.getDate()).padStart(2, '0');
        const rawMonth = parts.find((part) => part.type === 'month')?.value || '';
        const cleanMonth = rawMonth.replace(/[.\s]/g, '');
        const month = cleanMonth.charAt(0).toUpperCase() + cleanMonth.slice(1);
        return `${day} ${month}`;
      }

      updateDates() {
        const now = new Date();
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        const dispatchEnd = this.addBusinessDays(today, 1);
        const deliveryEnd = this.addBusinessDays(today, 3);
        const todayText = this.formatDate(today);
        const dispatchEndText = this.formatDate(dispatchEnd);
        const deliveryEndText = this.formatDate(deliveryEnd);

        this.querySelector('[data-vde-heading-window]').textContent = `${dispatchEndText} – ${deliveryEndText}`;
        this.querySelector('[data-vde-today]').textContent = todayText;
        this.querySelector('[data-vde-today]').dateTime = this.dateAttribute(today);
        this.querySelector('[data-vde-dispatch]').textContent = `${todayText} – ${dispatchEndText}`;
        this.querySelector('[data-vde-delivery]').textContent = `${dispatchEndText} – ${deliveryEndText}`;
      }

      scheduleMidnightUpdate() {
        window.clearTimeout(this.midnightTimer);

        const now = new Date();
        const nextMidnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0, 250);
        const delay = Math.max(1000, nextMidnight.getTime() - now.getTime());

        this.midnightTimer = window.setTimeout(() => {
          this.updateDates();
          this.scheduleMidnightUpdate();
        }, delay);
      }
    }
  );
}
